export default __webpack_public_path__ + "static/media/section32.a799249d.svg";